import {Rectangle as PixiRectangle} from 'pixi.js';

export class Rectangle extends PixiRectangle {
    public isEqual(rectangle: PixiRectangle): boolean {
        if (this.x !== rectangle.x) {
            return false;
        }

        if (this.y !== rectangle.y) {
            return false;
        }

        if (this.width !== rectangle.width) {
            return false;
        }

        if (this.height !== rectangle.height) {
            return false;
        }

        return true;
    }
}